import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { Tooltip, IconButton, TextField, CardActions, TablePagination, CircularProgress } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Card, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import classNames from 'classnames';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect } from 'react';
import './componentreg.css';
import { customerbasedshift } from '../../Services/app/masterservice';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'; // Ensure Swal is imported
import { shiftadd } from '../../Services/app/masterservice'; // Ensure shiftadd is imported
import ComponentEdit from '../Componentregistration/componentedit';
import ComponentAdd from '../Componentregistration/componentadd'
import { cleanCustomerId } from '../../Services/app/operatorservice';
const ComponentRegistration = () => {
    // Separate state for Add and Edit dialogs
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [editDialogData, setEditDialogData] = useState(null); // To store data for the edit dialog
    const [searchText, setSearchText] = useState('');
    const [lightboxUrl, setLightboxUrl] = useState(null);
    const [lightboxIsPdf, setLightboxIsPdf] = useState(false);
    const [sortColumn, setSortColumn] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // dialogOpenCount is used for background color in dialogs, tracks total open dialogs
    const [dialogOpenCount, setDialogOpenCount] = useState(0);
    const [datasource, setDatasource] = useState([]);
    // Yantra Intelligence detail modal state — shown when supervisor clicks the ✨ Yantra Intelligence badge on a row
    const [aiModalOpen, setAiModalOpen] = useState(false);
    const [aiModalRow, setAiModalRow] = useState(null);
    // Original "before" code fetched from full_prog telemetry for side-by-side diff
    const [aiOriginal, setAiOriginal] = useState(null);
    const [aiOriginalLoading, setAiOriginalLoading] = useState(false);
    const [aiViewMode, setAiViewMode] = useState('after'); // 'after' | 'before' | 'split'
    // Bulk Yantra Intelligence optimization modal state
    const [bulkAiOpen, setBulkAiOpen] = useState(false);
    const [bulkAiRunning, setBulkAiRunning] = useState({}); // { component_number: 'running' | 'done' | 'error' }
    // Inline cost editor state
    const [editingCostFor, setEditingCostFor] = useState(null); // component_number being edited, or null
    const [editingCostValue, setEditingCostValue] = useState('');
    const [savingCostFor, setSavingCostFor] = useState(null);
    const [onlyMissingCost, setOnlyMissingCost] = useState(false);
    const [recentActiveSet, setRecentActiveSet] = useState(new Set()); // program_no's seen in recent telemetry
    const [bulkAiResults, setBulkAiResults] = useState({}); // { component_number: { delta, error } }

    // Navigate to dedicated performance page
    const navigate = useNavigate();

    // Bulk Yantra Intelligence optimization: for one component, run the full pipeline
    // (fetch original → ai-suggest → ai-rewrite → save). Updates running
    // state + result so the modal can show progress per row.
    const runAiForComponent = async (row) => {
        const code = row.component_number;
        setBulkAiRunning(prev => ({ ...prev, [code]: 'running' }));
        try {
            const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
            const cid = cleanCustomerId(customerId);
            // 1) fetch original full_prog
            const origResp = await axios.get(`${base}/api/buddy/gcode/original-for-component`, {
                params: { customer_id: cid, component_number: code },
            });
            const original = origResp.data;
            if (!original?.text) throw new Error('No program found on any machine for this component');

            // 2) call ai-rewrite directly (it produces both suggestions + optimized code)
            const rewriteResp = await axios.post(`${base}/api/buddy/gcode/ai-rewrite`, {
                code: original.text,
                filename: `${code}.nc`,
                customer_id: cid,
                componentInfo: {
                    master: { component_number: code, component_name: row.component_name },
                },
            });
            const ai = rewriteResp.data;
            if (!ai?.text) throw new Error('Yantra Intelligence did not return optimized code');

            // 3) save back to gcode_ai_outputs (which we'll then re-embed into master)
            await axios.post(`${base}/api/buddy/gcode/save-ai-output`, {
                customer_id: cid,
                component_number: code,
                program_no: original.o_number,
                ai_text: ai.text,
                suggestions: ai.suggestions || [],
                deltas: {
                    lineDelta: ai.lineDelta || 0,
                    sizeDelta: ai.sizeDelta || 0,
                    timeDeltaSec: ai.timeDeltaSec || 0,
                    rapidDeltaMm: ai.rapidDeltaMm || 0,
                    toolChangeDelta: ai.toolChangeDelta || 0,
                },
            });

            setBulkAiResults(prev => ({
                ...prev,
                [code]: {
                    timeDeltaSec: ai.timeDeltaSec || 0,
                    lineDelta: ai.lineDelta || 0,
                    suggestions: (ai.suggestions || []).length,
                },
            }));
            setBulkAiRunning(prev => ({ ...prev, [code]: 'done' }));
        } catch (e) {
            console.error('Bulk Yantra Intelligence failed for', code, e);
            setBulkAiResults(prev => ({ ...prev, [code]: { error: e?.message || String(e) } }));
            setBulkAiRunning(prev => ({ ...prev, [code]: 'error' }));
        }
    };

    const openPerformanceView = (row) => {
        const code = row.component_number || row.code || row.compcode || "";
        const name = row.component_name || row.name || "";
        const q = new URLSearchParams({
            customer_id: cleanCustomerId(customerId),
            code, name, days: "30",
        }).toString();
        navigate(`/component-performance?${q}`);
    };
    const customerId = localStorage.getItem('CustomerID');
    const filteredDatasource = useMemo(() => {
        return datasource.filter(row => {
            const matchesSearch = row.component_name?.toLowerCase().includes(searchText.toLowerCase()) ||
                row?.component_number?.toLowerCase().includes(searchText.toLowerCase());
            if (!matchesSearch) return false;
            if (onlyMissingCost) {
                const hasCost = row.cost_per_part != null && row.cost_per_part !== '';
                if (hasCost) return false;
            }
            return true;
        });
    }, [datasource, searchText, onlyMissingCost]);
    // Handlers for Add Shift dialog
    const handleOpenAddDialog = () => {
        setIsAddDialogOpen(true);
        setDialogOpenCount(prevCount => prevCount + 1);
    };
    const handleCloseAddDialog = (event, reason) => {
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
        setIsAddDialogOpen(false);
        setDialogOpenCount(prevCount => Math.max(0, prevCount - 1)); // Ensure count doesn't go below 0
        getComponents(); // Refresh data after add/close
    };
    // Handlers for Edit Shift dialog
    const handleOpenEditDialog = (rowData) => {
        setEditDialogData(rowData); // Set the data for the specific row being edited
        setIsEditDialogOpen(true);
        setDialogOpenCount(prevCount => prevCount + 1);
    };

    const handleCloseEditDialog = (event, reason) => {
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
        setIsEditDialogOpen(false);
        setEditDialogData(null); // Clear the data when dialog closes
        setDialogOpenCount(prevCount => Math.max(0, prevCount - 1)); // Ensure count doesn't go below 0
        getComponents(); // Refresh data after edit/close
    };


    const deleteshift = (row) => {
        console.log("Attempting to delete row:", row);

        Swal.fire({
            title: 'Are you sure you want to delete this record?',
            // text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            allowOutsideClick: false,
            allowEscapeKey: false
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Fetch the current list of shifts from the backend
                    const key = 'component';
                    const currentDataResponse = await customerbasedshift(customerId, key);
                    const allShifts = currentDataResponse[0]?.value || [];

                    // Filter out the shift to be deleted based on its ID
                    const updatedShifts = allShifts.filter(shift => {
                        // Handle both string IDs and MongoDB ObjectId format
                        const shiftId = shift.id?.$oid || shift.id;
                        const rowId = row.id?.$oid || row.id;
                        return shiftId !== rowId;
                    });

                    // Prepare the payload to send back to the API
                    // This structure aligns with how shifts are added/updated
                    const formData = {
                        component: updatedShifts,
                        lastUpdateTs: Date.now() // Update timestamp
                    };

                    const scope = 'SERVER_SCOPE'; // As seen in shiftadd.js context

                    // Call the API to update the shifts (effectively deleting the selected one)
                    const response = await shiftadd(formData, customerId, scope);

                    if (response.msg) {
                        Swal.fire('Deleted!', response.msg, 'success');
                    } else {
                        Swal.fire('Deleted!', 'Your component has been deleted successfully.', 'success');
                    }
                    getComponents(); // Refresh the data in the table after deletion
                } catch (error) {
                    console.error('Error deleting component:', error);
                    Swal.fire('Error!', 'Failed to delete the component: ' + error.message, 'error');
                }
            } else {
                // User clicked "No" or outside the popup
                Swal.fire('Cancelled');
            }
        });
    };

    // const convertTimes = (time) => {
    //     const date = new Date(time);
    //     return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
    // };

    const getComponents = async () => {
        try {
            const componentKey = "component";
            const autoTargetKey = "autotarget";

            const [componentRes, autoTargetRes] = await Promise.all([
                customerbasedshift(customerId, componentKey),
                customerbasedshift(customerId, autoTargetKey)
            ]);

            const components = componentRes?.[0]?.value || [];
            const autoTargets = autoTargetRes?.[0]?.value || [];
            console.log(autoTargets, 'autotargets')
            const mappedJson = components.map(comp => {
                const match = autoTargets.find(
                    auto => auto.component_name === comp.component_name
                );

                return {
                    ...comp,
                    auto_target: match
                        ? {
                            cycle_levels: match.cycle_level || "00:00:00",
                            handling_levels: match.handling_level || "00:00:00"
                        }
                        : null
                };
            });

            console.log("Mapped datasource:", mappedJson);
            setDatasource(mappedJson);

        } catch (error) {
            console.error("Error fetching components:", error);
            setDatasource([]);
        }
    };
    console.log('datasource', datasource)

    // const getTotalShiftHours = (start, end, breakTime) => {
    //     const parseTime = (str) => {
    //         const [h, m, s] = str.split(':').map(Number);
    //         return h * 3600 + m * 60 + s;
    //     };

    //     const startSec = parseTime(start);
    //     const endSec = parseTime(end);
    //     const breakSec = parseTime(breakTime);

    //     let totalSec = endSec - startSec - breakSec;

    //     // Handle overnight shifts (e.g., 22:00 to 06:00)
    //     if (totalSec < 0) {
    //         totalSec += 24 * 3600;
    //     }

    //     const hours = String(Math.floor(totalSec / 3600)).padStart(2, '0');
    //     const minutes = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
    //     const seconds = String(totalSec % 60).padStart(2, '0');

    //     return `${hours}:${minutes}:${seconds}`;
    // };


    // Convert HH:MM:SS to seconds for numeric sorting
    const hmsToSec = (v) => {
        if (!v) return 0;
        const m = String(v).match(/^(\d+):(\d+):(\d+)$/);
        if (m) return Number(m[1])*3600 + Number(m[2])*60 + Number(m[3]);
        const n = Number(v);
        return Number.isFinite(n) ? n : 0;
    };
    const sortedDatasource = useMemo(() => {
        // Default sort (no explicit sortColumn): missing-cost AND recently-active components first,
        // so the admin sees the highest-impact rows to fill at the top of the list.
        if (!sortColumn) {
            const arr = [...filteredDatasource];
            arr.sort((a, b) => {
                const aMissing = !(a.cost_per_part != null && a.cost_per_part !== '');
                const bMissing = !(b.cost_per_part != null && b.cost_per_part !== '');
                const aActive = recentActiveSet.has(String(a.program_no || '').toUpperCase()) ? 1 : 0;
                const bActive = recentActiveSet.has(String(b.program_no || '').toUpperCase()) ? 1 : 0;
                // Priority 1: rows that are BOTH missing-cost AND recently active
                const aPriority = (aMissing && aActive) ? 2 : (aActive ? 1 : 0);
                const bPriority = (bMissing && bActive) ? 2 : (bActive ? 1 : 0);
                if (aPriority !== bPriority) return bPriority - aPriority;
                return String(a.component_number || '').localeCompare(String(b.component_number || ''));
            });
            return arr;
        }
        const arr = [...filteredDatasource];
        const dir = sortDirection === 'asc' ? 1 : -1;
        const isTime = ['cycle_time','handling_time','setupTime'].includes(sortColumn);
        const isNum = ['cost_per_part','factorval'].includes(sortColumn);
        // Virtual Yantra Intelligence column: rows WITH ai_text sort to the top (or bottom on desc),
        // then within the group, by time saved (timeDeltaSec descending = best savings first).
        const isAi = sortColumn === 'ai';
        arr.sort((a, b) => {
            if (isAi) {
                const aHas = a?.ai_text ? 1 : 0;
                const bHas = b?.ai_text ? 1 : 0;
                if (aHas !== bHas) return (bHas - aHas) * dir;
                const at = a?.ai_deltas?.timeDeltaSec ?? 0;
                const bt = b?.ai_deltas?.timeDeltaSec ?? 0;
                return (bt - at) * dir;
            }
            let av = a?.[sortColumn]; let bv = b?.[sortColumn];
            if (isTime) { av = hmsToSec(av); bv = hmsToSec(bv); }
            else if (isNum) { av = Number(av) || 0; bv = Number(bv) || 0; }
            else { av = String(av ?? '').toLowerCase(); bv = String(bv ?? '').toLowerCase(); }
            if (av < bv) return -1 * dir;
            if (av > bv) return  1 * dir;
            return 0;
        });
        return arr;
    }, [filteredDatasource, sortColumn, sortDirection, recentActiveSet]);

    const toggleSort = (col) => {
        if (sortColumn === col) {
            setSortDirection(d => d === 'asc' ? 'desc' : 'asc');
        } else {
            setSortColumn(col);
            setSortDirection('asc');
        }
    };
    const sortIcon = (col) => {
        if (sortColumn !== col) return <span style={{ color: '#cbd5e1', fontSize: 10, marginLeft: 4 }}>▴▾</span>;
        return <span style={{ color: '#1e293b', fontSize: 11, marginLeft: 4, fontWeight: 800 }}>{sortDirection === 'asc' ? '▴' : '▾'}</span>;
    };
    const HeaderSort = ({ col, label }) => (
        <TableCell onClick={() => toggleSort(col)} style={{ cursor: 'pointer', userSelect: 'none' }}>
            {label}{sortIcon(col)}
        </TableCell>
    );

    const paginatedData = useMemo(() => {
        const start = page * rowsPerPage;
        return sortedDatasource.slice(start, start + rowsPerPage);
    }, [sortedDatasource, page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    useEffect(() => {
        getComponents();
    }, []);

    useEffect(() => {
        setPage(0);
    }, [searchText]);

    // Fetch recently-active programs so we can surface components that actually
    // ran in production at the top of the list (those benefit most from cost data).
    useEffect(() => {
        const SERVER = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
        const cid = cleanCustomerId(customerId);
        if (!cid) return;
        axios.get(`${SERVER}/api/buddy/gcode/programs`, { params: { customer_id: cid } })
            .then(r => {
                const progs = Array.isArray(r.data) ? r.data : [];
                const set = new Set(progs.map(p => String(p.program_no || '').toUpperCase()).filter(Boolean));
                setRecentActiveSet(set);
            })
            .catch(() => { /* non-fatal; just won't show recent-active sort */ });
    }, [customerId]);

    // Save a single component's cost_per_part by writing back the whole array.
    // Uses the same shiftadd API path the rest of the page uses for master writes.
    const saveCostInline = async (componentNumber, newCost) => {
        const numeric = newCost === '' || newCost === null ? '' : Number(newCost);
        if (newCost !== '' && (Number.isNaN(numeric) || numeric < 0)) {
            Swal.fire({ icon: 'error', title: 'Invalid cost', text: 'Enter a non-negative number' });
            return;
        }
        setSavingCostFor(componentNumber);
        try {
            const updated = datasource.map(r =>
                r.component_number === componentNumber ? { ...r, cost_per_part: numeric === '' ? '' : numeric } : r
            );
            // shiftadd writes the whole `component` attribute as one customer-scope payload
            await shiftadd({ component: updated }, customerId, 'SERVER_SCOPE');
            setDatasource(updated);
            setEditingCostFor(null);
            setEditingCostValue('');
            Swal.fire({ icon: 'success', title: 'Saved', timer: 700, showConfirmButton: false, toast: true, position: 'top-end' });
        } catch (e) {
            Swal.fire({ icon: 'error', title: 'Save failed', text: e?.response?.data?.message || e?.message || 'Unknown error' });
        } finally {
            setSavingCostFor(null);
        }
    };

    const timeToSeconds = (time) => {
        if (!time) return 0;
        const [h = 0, m = 0, s = 0] = String(time).split(":").map(Number);
        return h * 3600 + m * 60 + s;
    };

    const secondsToTime = (sec) => {
        if (sec === '' || sec === null || sec === undefined) return '';
        const sign = sec < 0 ? "-" : "";
        sec = Math.abs(sec);

        const h = String(Math.floor(sec / 3600)).padStart(2, "0");
        const m = String(Math.floor((sec % 3600) / 60)).padStart(2, "0");
        const s = String(sec % 60).padStart(2, "0");

        return `${sign}${h}:${m}:${s}`;
    };

    const handleExportCSV = () => {
        const headers = [
            "Component Name",
            "Component Number",
            "Factor",
            "Factor Value",
            "Standard Machining Time",
            "Auto Machining Time",
            "Machining Time Diff",
            "Standard Handling Time",
            "Actual Handling Time",
            "Handling Time Diff",
            "Setup Time"
        ];

        const rows = filteredDatasource.map(row => {
            const cycleTime = row.cycle_time || "-";
            const cycleLevel = row.auto_target?.cycle_levels || "-";
            const handlingTime = row.handling_time || "-";
            const handlingLevel = row.auto_target?.handling_levels || "-";

            const diffCycle =
                row.cycle_time && row.auto_target?.cycle_levels
                    ? secondsToTime(
                        timeToSeconds(row.cycle_time) -
                        timeToSeconds(row.auto_target?.cycle_levels)
                    )
                    : "-";

            const diffHandling =
                row.handling_time && row.auto_target?.handling_levels
                    ? secondsToTime(
                        timeToSeconds(row.handling_time) -
                        timeToSeconds(row.auto_target?.handling_levels)
                    )
                    : "-";

            return [
                row.component_name || "-",
                row.component_number || "-",
                row.factor || "-",
                row.factorval || "-",
                cycleTime,
                cycleLevel,
                diffCycle || "-",
                handlingTime,
                handlingLevel,
                diffHandling || "-",
                row.setupTime || "-"
            ];
        });

        const csvContent = [headers, ...rows]
            .map(r => r.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(","))
            .join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "components.csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
    };


    return (
        <div className="pages" style={{
            paddingLeft: "10px"
        }}>
            <div className="pagecontents">
                <div className="left-labels">
                    <div className="shift-content">
                        <h5>Component Registration</h5>
                        <Tooltip title="Bulk-optimize G-code for components that have a program loaded but no Yantra Intelligence yet">
                            <Button
                                size="small"
                                variant="outlined"
                                onClick={() => setBulkAiOpen(true)}
                                sx={{
                                    marginLeft: '12px',
                                    borderColor: '#7c3aed',
                                    color: '#6d28d9',
                                    textTransform: 'none',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    ':hover': { borderColor: '#6d28d9', backgroundColor: '#f5f3ff' },
                                }}
                            >
                                🧠 Bulk Yantra Intelligence Optimize
                            </Button>
                        </Tooltip>
                        <Tooltip title={onlyMissingCost ? 'Show all components' : 'Show only components missing cost (₹)'}>
                            <Button
                                variant={onlyMissingCost ? 'contained' : 'outlined'}
                                size="small"
                                onClick={() => setOnlyMissingCost(v => !v)}
                                sx={{
                                    borderColor: '#f59e0b',
                                    color: onlyMissingCost ? '#fff' : '#b45309',
                                    background: onlyMissingCost ? '#f59e0b' : '#fff',
                                    textTransform: 'none', fontSize: 12, fontWeight: 600,
                                    ':hover': { borderColor: '#d97706', background: onlyMissingCost ? '#d97706' : '#fffbeb' },
                                    ml: 1,
                                }}
                            >
                                {onlyMissingCost ? '✓ ' : ''}🟠 Missing Cost
                                {onlyMissingCost && ` (${filteredDatasource.length})`}
                            </Button>
                        </Tooltip>
                        <div className="add_new">
                            <Tooltip title="Add Component">
                                <IconButton className="circle" onClick={handleOpenAddDialog}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                            <ComponentAdd
                                open={isAddDialogOpen} // Use specific state for add dialog
                                handleClose={handleCloseAddDialog} // Use specific close handler
                                handleAdd={handleCloseAddDialog} // Call close handler on successful add
                                dialogOpenCount={dialogOpenCount}
                                datasource={datasource}
                                customerId={customerId}
                                setDatasource={setDatasource}
                            // dialogData is intentionally omitted for ShiftAdd to ensure it's empty
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {cleanCustomerId(customerId) === window._env_.CUSTOMER_ID && (
                            <Button
                                variant="outlined"
                                onClick={handleExportCSV}
                                sx={{
                                    minWidth: 120,
                                    height: 54,
                                    borderColor: '#f47803',
                                    color: '#f47803',
                                    '&:hover': { borderColor: '#f47803', color: '#f47803', background: '#e9e9e9' },
                                    textTransform: 'none',
                                    fontSize: "16px",
                                    fontWeight: 'bold',
                                }}
                            >
                                Export CSV
                            </Button>
                        )}
                        <TextField
                            label="Search Component Name or Number"
                            type="text"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            InputLabelProps={{
                                sx: { color: 'black', '&.Mui-focused': { color: 'orange' } },
                            }}
                            sx={{
                                minWidth: 300
                            }}
                        />
                    </div>
                </div>

                <Card className="card_sec">
                    <div className="example-container">
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Image</TableCell>
                                    <TableCell>Diagram</TableCell>
                                    <HeaderSort col="component_name" label="Component Name" />
                                    {(cleanCustomerId(customerId) != window._env_.GPLAST_CUSTOMER_ID) && (<HeaderSort col="component_number" label="Component Number" />)}
                                    <HeaderSort col="program_no" label="Program No" />
                                    <HeaderSort col="cost_per_part" label="Cost (₹)" />
                                    {(cleanCustomerId(customerId) === window._env_.ATECH_CUSTOMER_ID || cleanCustomerId(customerId) === window._env_.HITECH_CUSTOMER_ID) && (<HeaderSort col="operation_type" label="Operation Type" />)}
                                    {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<HeaderSort col="item_code" label="Item Code" />)}
                                    {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<HeaderSort col="process_name" label="Process Name" />)}
                                    {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<HeaderSort col="operation_number" label="Operation Number" />)}
                                    {/* <TableCell>Route Card</TableCell> */}
                                    {/* <TableCell>Drawing Code</TableCell> */}
                                    {/* <TableCell>Mould Name</TableCell> */}
                                    {/* <TableCell>Mould Number</TableCell> */}
                                    {cleanCustomerId(customerId) === window._env_.CUSTOMER_ID ? (
                                        <>
                                            <HeaderSort col="cycle_time" label="Standard Machining Time" />
                                            <TableCell>Actual Machining Time</TableCell>
                                            <HeaderSort col="handling_time" label="Standard Handling Time" />
                                            <TableCell>Actual Handling Time</TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <HeaderSort col="cycle_time" label="Machining Time" />
                                            <HeaderSort col="handling_time" label="Handling Time" />
                                        </>
                                    )}
                                    <HeaderSort col="setupTime" label="Setup Time" />
                                    <HeaderSort col="ai" label="Yantra Intelligence" />
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedData.length > 0 ? (
                                    paginatedData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.image_url ? (
                                                    <img src={`${(window._env_?.SERVER_URL2 || '').replace(/\/$/, '')}${row.image_url}`}
                                                         alt={row.component_name || 'component'}
                                                         onClick={() => { setLightboxUrl(`${(window._env_?.SERVER_URL2 || '').replace(/\/$/, '')}${row.image_url}`); setLightboxIsPdf(false); }}
                                                         style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--y-border, #e5e7eb)', cursor: 'zoom-in' }} />
                                                ) : (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, background: 'var(--y-bg, #f3f4f6)', border: '1px dashed #d1d5db', borderRadius: 4, color: '#9ca3af', fontSize: 18 }}>&times;</span>
                                                )}
                                            </TableCell>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.diagram_url ? (
                                                    row.diagram_url.toLowerCase().endsWith('.pdf') ? (
                                                        <span
                                                            onClick={() => { setLightboxUrl(`${(window._env_?.SERVER_URL2 || '').replace(/\/$/, '')}${row.diagram_url}`); setLightboxIsPdf(true); }}
                                                            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 4, color: '#b45309', fontSize: 10, fontWeight: 800, cursor: 'pointer' }}
                                                            title="Open PDF"
                                                        >PDF</span>
                                                    ) : (
                                                        <img src={`${(window._env_?.SERVER_URL2 || '').replace(/\/$/, '')}${row.diagram_url}`}
                                                             alt="diagram"
                                                             onClick={() => { setLightboxUrl(`${(window._env_?.SERVER_URL2 || '').replace(/\/$/, '')}${row.diagram_url}`); setLightboxIsPdf(false); }}
                                                             style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid var(--y-border, #e5e7eb)', cursor: 'zoom-in' }} />
                                                    )
                                                ) : (
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 40, height: 40, background: 'var(--y-bg, #f3f4f6)', border: '1px dashed #d1d5db', borderRadius: 4, color: '#9ca3af', fontSize: 11 }}>DIAG</span>
                                                )}
                                            </TableCell>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.component_name || '---'}
                                            </TableCell>
                                            {(cleanCustomerId(customerId) != window._env_.GPLAST_CUSTOMER_ID) && (<TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.component_number || '---'}
                                            </TableCell>)}
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                <span style={{ fontWeight: 600, color: row.program_no ? '#111827' : '#9ca3af' }}>{row.program_no || '—'}</span>
                                            </TableCell>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {editingCostFor === row.component_number ? (
                                                    <input
                                                        type="number"
                                                        autoFocus
                                                        value={editingCostValue}
                                                        onChange={(e) => setEditingCostValue(e.target.value)}
                                                        onBlur={() => saveCostInline(row.component_number, editingCostValue)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') { e.preventDefault(); saveCostInline(row.component_number, editingCostValue); }
                                                            if (e.key === 'Escape') { setEditingCostFor(null); setEditingCostValue(''); }
                                                        }}
                                                        disabled={savingCostFor === row.component_number}
                                                        placeholder="₹ per part"
                                                        style={{ width: 100, padding: '4px 6px', fontSize: 13, border: '1px solid #f59e0b', borderRadius: 4, outline: 'none' }}
                                                    />
                                                ) : (
                                                    <span
                                                        onClick={() => { setEditingCostFor(row.component_number); setEditingCostValue(row.cost_per_part != null ? String(row.cost_per_part) : ''); }}
                                                        title="Click to edit"
                                                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}
                                                    >
                                                        {row.cost_per_part != null && row.cost_per_part !== '' ? (
                                                            <span style={{ fontWeight: 700, color: '#065f46' }}>₹ {Number(row.cost_per_part).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        ) : (
                                                            <>
                                                                <span style={{ width: 8, height: 8, borderRadius: '50%', background: '#f59e0b', display: 'inline-block' }} title="Missing cost" />
                                                                <span style={{ color: '#9ca3af', fontStyle: 'italic', fontSize: 12 }}>add cost</span>
                                                            </>
                                                        )}
                                                    </span>
                                                )}
                                            </TableCell>
                                            {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row?.item_code || '---'}
                                            </TableCell>)}
                                            {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row?.process_name || '---'}
                                            </TableCell>)}
                                            {(cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) && (<TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row?.operation_number || '---'}
                                            </TableCell>)}
                                            {(cleanCustomerId(customerId) === window._env_.ATECH_CUSTOMER_ID || cleanCustomerId(customerId) === window._env_.HITECH_CUSTOMER_ID) && (<TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.operation_type || '---'}
                                            </TableCell>)}
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.cycle_time || '---'}
                                            </TableCell>
                                            {cleanCustomerId(customerId) === window._env_.CUSTOMER_ID && (
                                                <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                    {row.auto_target?.cycle_levels || '---'}
                                                </TableCell>)}
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.handling_time || '---'}
                                            </TableCell>
                                            {cleanCustomerId(customerId) === window._env_.CUSTOMER_ID && (
                                                <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                    {row.auto_target?.handling_levels || '---'}
                                                </TableCell>)}
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.setupTime || '---'}
                                            </TableCell>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                {row.ai_text ? (
                                                    <Tooltip title="View Yantra Intelligence-optimized G-code, suggestions & savings">
                                                        <span
                                                            onClick={async () => {
                                                                setAiModalRow(row);
                                                                setAiModalOpen(true);
                                                                setAiOriginal(null);
                                                                setAiViewMode('after');
                                                                // Fetch original full_prog for side-by-side diff
                                                                setAiOriginalLoading(true);
                                                                try {
                                                                    const base = (window._env_?.SERVER_URL2 || '').replace(/\/$/, '');
                                                                    const cid = cleanCustomerId(customerId);
                                                                    const resp = await axios.get(
                                                                        `${base}/api/buddy/gcode/original-for-component`,
                                                                        { params: { customer_id: cid, component_number: row.component_number } },
                                                                    );
                                                                    setAiOriginal(resp.data || null);
                                                                } catch (e) {
                                                                    console.warn('original fetch failed', e);
                                                                    setAiOriginal(null);
                                                                } finally {
                                                                    setAiOriginalLoading(false);
                                                                }
                                                            }}
                                                            style={{
                                                                cursor: 'pointer',
                                                                background: '#ecfdf5',
                                                                color: '#047857',
                                                                border: '1px solid #a7f3d0',
                                                                padding: '2px 10px',
                                                                borderRadius: 999,
                                                                fontSize: 11,
                                                                fontWeight: 600,
                                                                display: 'inline-block',
                                                                whiteSpace: 'nowrap',
                                                            }}
                                                        >
                                                            ✨ Yantra Intelligence{(() => {
                                                                const t = row.ai_deltas?.timeDeltaSec;
                                                                if (t == null || t === 0) return '';
                                                                return ` ${t > 0 ? '−' : '+'}${Math.abs(t)}s`;
                                                            })()}
                                                        </span>
                                                    </Tooltip>
                                                ) : (
                                                    <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>
                                                )}
                                            </TableCell>
                                            <TableCell className={classNames({ 'odd-row': index % 2 !== 0, 'even-row': index % 2 === 0 })}>
                                                <Tooltip title="View Performance (Best / Good / Bad)">
                                                    <IconButton onClick={() => openPerformanceView(row)}>
                                                        <VisibilityIcon sx={{ color: '#1d4ed8' }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Edit Component">
                                                    <IconButton onClick={() => handleOpenEditDialog(row)}>
                                                        <EditIcon sx={{ color: 'black' }} />
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title="Delete Component">
                                                    <IconButton onClick={() => deleteshift(row, datasource)}>
                                                        <DeleteIcon sx={{ color: 'black' }} />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={10} align="center" style={{
                                            padding: '20px', background: '#EDEDED', fontSize: '1rem',
                                            letterSpacing: ' 0.02rem'
                                        }}>
                                            No Results found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>

                        </Table>
                    </div>
                    <CardActions sx={{ px: 2, justifyContent: 'end', background: '#dddddd' }}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            component="div"
                            count={filteredDatasource.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            labelRowsPerPage="Items per page"
                        />
                    </CardActions>
                </Card>
            </div>
            {/* Render ShiftEdit conditionally outside the table loop */}
            {isEditDialogOpen && (
                <ComponentEdit
                    open={isEditDialogOpen} // Use specific state for edit dialog
                    handleClose={handleCloseEditDialog} // Use specific close handler
                    handleAdd={handleCloseEditDialog} // Call close handler on successful edit
                    dialogData={editDialogData} // Pass the stored row data
                    dialogOpenCount={dialogOpenCount}
                    datasource={datasource}
                    customerId={customerId}
                    setDatasource={setDatasource}
                />
            )}
            {/* Lightbox preview for image / diagram (PDF or image) */}
            {lightboxUrl && (
                <Dialog
                    open={!!lightboxUrl}
                    onClose={() => { setLightboxUrl(null); setLightboxIsPdf(false); }}
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <span>{lightboxIsPdf ? 'Diagram (PDF)' : 'Preview'}</span>
                        <IconButton
                            onClick={() => { setLightboxUrl(null); setLightboxIsPdf(false); }}
                            size="small"
                            aria-label="close"
                        >
                            <span style={{ fontSize: 20, lineHeight: 1 }}>&times;</span>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers style={{ padding: 0, background: '#000' }}>
                        {lightboxIsPdf ? (
                            <iframe
                                src={lightboxUrl}
                                title="diagram"
                                style={{ width: '100%', height: '80vh', border: 'none', background: 'var(--y-bg, #fff)' }}
                            />
                        ) : (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                                <img
                                    src={lightboxUrl}
                                    alt="preview"
                                    style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
                                />
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="outlined"
                            href={lightboxUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                        >Open in new tab</Button>
                        <Button
                            variant="contained"
                            color="warning"
                            onClick={() => { setLightboxUrl(null); setLightboxIsPdf(false); }}
                        >Close</Button>
                    </DialogActions>
                </Dialog>
            )}

            {/* Yantra Intelligence detail modal — shown when supervisor clicks the ✨ Yantra Intelligence badge */}
            <Dialog
                open={aiModalOpen}
                onClose={() => setAiModalOpen(false)}
                maxWidth="lg"
                fullWidth
                sx={{ '& .MuiDialog-paper': { borderRadius: '10px' } }}
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <span style={{ fontSize: 22 }}>✨</span>
                    <span style={{ fontSize: 17, fontWeight: 600 }}>Yantra Intelligence G-Code Optimization</span>
                    {aiModalRow && (
                        <span style={{ marginLeft: 12, fontSize: 13, color: '#6b7280', fontWeight: 400 }}>
                            {aiModalRow.component_number} · {aiModalRow.component_name}
                        </span>
                    )}
                </DialogTitle>
                <DialogContent dividers sx={{ padding: 0 }}>
                    {aiModalRow && (() => {
                        const d = aiModalRow.ai_deltas || {};
                        const deltaValues = [d.timeDeltaSec, d.lineDelta, d.sizeDelta, d.rapidDeltaMm, d.toolChangeDelta];
                        const hasAnyDelta = deltaValues.some(v => v != null && v !== 0);
                        return (
                        <div>
                            {/* Savings strip — only shown when at least one delta is non-zero */}
                            {hasAnyDelta ? (
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 0, borderBottom: '1px solid var(--y-border, #e5e7eb)', background: 'var(--y-bg-soft, #f9fafb)' }}>
                                    {[
                                        { label: 'Time saved', value: d.timeDeltaSec, unit: 's' },
                                        { label: 'Lines removed', value: d.lineDelta, unit: '' },
                                        { label: 'Bytes saved', value: d.sizeDelta, unit: 'B' },
                                        { label: 'Rapid travel cut', value: d.rapidDeltaMm, unit: 'mm' },
                                        { label: 'Tool changes', value: d.toolChangeDelta, unit: '' },
                                    ].map((m, i) => {
                                        const v = m.value;
                                        const sign = v == null ? '0' : (v > 0 ? '−' : v < 0 ? '+' : '0');
                                        const display = v == null || v === 0 ? '0' : `${sign}${Math.abs(v)}${m.unit}`;
                                        const color = v == null || v === 0 ? '#9ca3af' : (v > 0 ? '#047857' : '#b91c1c');
                                        return (
                                            <div key={i} style={{ padding: '12px 14px', borderRight: i < 4 ? '1px solid #e5e7eb' : 'none', textAlign: 'center' }}>
                                                <div style={{ fontSize: 10, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.5, fontWeight: 600 }}>{m.label}</div>
                                                <div style={{ fontSize: 18, fontWeight: 700, color, marginTop: 4 }}>{display}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div style={{ padding: '10px 16px', background: 'var(--y-bg-soft, #f9fafb)', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontSize: 12, color: '#6b7280' }}>
                                    💡 <b>Suggestions only</b> — Yantra Intelligence proposed improvements but the optimized code below hasn't been measured against the original yet (or was a draft pass with no quantified savings).
                                </div>
                            )}

                            {/* Suggestions list */}
                            {Array.isArray(aiModalRow.ai_suggestions) && aiModalRow.ai_suggestions.length > 0 && (
                                <div style={{ padding: '12px 16px', borderBottom: '1px solid var(--y-border, #e5e7eb)' }}>
                                    <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>
                                        💡 Suggestions ({aiModalRow.ai_suggestions.length})
                                    </div>
                                    <ul style={{ margin: 0, paddingLeft: 20, fontSize: 13, color: '#374151', lineHeight: 1.6 }}>
                                        {aiModalRow.ai_suggestions.map((s, i) => (
                                            <li key={i} style={{ marginBottom: 6 }}>
                                                {typeof s === 'string' ? s : (
                                                    <>
                                                        {s.title && <b>{s.title}: </b>}
                                                        {s.description || s.detail || JSON.stringify(s)}
                                                    </>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            {/* G-Code viewer with Before / After / Split toggle */}
                            <div style={{ padding: '12px 16px' }}>
                                <div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                    🔧 G-Code Viewer
                                    <span style={{ display: 'inline-flex', gap: 4, marginLeft: 8 }}>
                                        {[
                                            { id: 'before', label: 'Before (original)' },
                                            { id: 'after', label: 'After (Yantra Intelligence)' },
                                            { id: 'split', label: 'Side-by-side' },
                                        ].map(t => (
                                            <button
                                                key={t.id}
                                                onClick={() => setAiViewMode(t.id)}
                                                disabled={t.id !== 'after' && !aiOriginal?.text}
                                                style={{
                                                    padding: '4px 10px',
                                                    fontSize: 11,
                                                    fontWeight: 600,
                                                    background: aiViewMode === t.id ? '#ec6e17' : '#fff',
                                                    color: aiViewMode === t.id ? '#fff' : '#6b7280',
                                                    border: '1px solid ' + (aiViewMode === t.id ? '#ec6e17' : '#d1d5db'),
                                                    borderRadius: 4,
                                                    cursor: t.id !== 'after' && !aiOriginal?.text ? 'not-allowed' : 'pointer',
                                                    opacity: t.id !== 'after' && !aiOriginal?.text ? 0.4 : 1,
                                                }}
                                            >
                                                {t.label}
                                            </button>
                                        ))}
                                    </span>
                                    <span style={{ marginLeft: 'auto', display: 'flex', gap: 6, alignItems: 'center' }}>
                                        {aiOriginal?.device_id && (
                                            <Button
                                                size="small"
                                                variant="contained"
                                                onClick={() => {
                                                    setAiModalOpen(false);
                                                    navigate(`/gcode-optimizer?device=${aiOriginal.device_id}&component=${aiModalRow.component_number}`);
                                                }}
                                                sx={{ textTransform: 'none', fontSize: 11, backgroundColor: '#7c3aed', ':hover': { backgroundColor: '#6d28d9' } }}
                                            >
                                                🎬 Open Animation
                                            </Button>
                                        )}
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            onClick={() => {
                                                const txt = aiViewMode === 'before' ? (aiOriginal?.text || '') : (aiModalRow.ai_text || '');
                                                navigator.clipboard.writeText(txt);
                                                Swal.fire({ title: 'Copied', icon: 'success', timer: 1200, showConfirmButton: false });
                                            }}
                                            sx={{ textTransform: 'none', fontSize: 11 }}
                                        >
                                            Copy {aiViewMode === 'before' ? 'Before' : 'After'}
                                        </Button>
                                    </span>
                                </div>

                                {aiOriginalLoading && (
                                    <div style={{ padding: 12, fontSize: 12, color: '#6b7280' }}>Loading original program from telemetry…</div>
                                )}
                                {!aiOriginalLoading && !aiOriginal?.text && (
                                    <div style={{ padding: 8, fontSize: 11, color: '#9a3412', background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: 4, marginBottom: 8 }}>
                                        No original program found in telemetry for this component (no machine has run it in last 30 days). Showing Yantra Intelligence-optimized only.
                                    </div>
                                )}
                                {aiOriginal?.text && (
                                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 6 }}>
                                        Original from <b>{aiOriginal.device_name}</b> · program <b style={{ color: '#7c3aed', fontFamily: 'monospace' }}>{aiOriginal.o_number || '?'}</b> · loaded {aiOriginal.ts_ist}
                                    </div>
                                )}

                                {aiViewMode === 'split' && aiOriginal?.text ? (
                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4 }}>Before · {aiOriginal.text.length} chars</div>
                                            <pre style={{
                                                background: '#0f172a', color: '#fca5a5', padding: '10px 12px', borderRadius: 6,
                                                fontSize: 11, lineHeight: 1.4, maxHeight: 400, overflow: 'auto',
                                                fontFamily: 'Consolas, Monaco, monospace', margin: 0, whiteSpace: 'pre',
                                            }}>{aiOriginal.text}</pre>
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', marginBottom: 4 }}>After · {aiModalRow.ai_text?.length || 0} chars</div>
                                            <pre style={{
                                                background: '#0f172a', color: '#86efac', padding: '10px 12px', borderRadius: 6,
                                                fontSize: 11, lineHeight: 1.4, maxHeight: 400, overflow: 'auto',
                                                fontFamily: 'Consolas, Monaco, monospace', margin: 0, whiteSpace: 'pre',
                                            }}>{aiModalRow.ai_text || '(no g-code)'}</pre>
                                        </div>
                                    </div>
                                ) : (
                                    <pre style={{
                                        background: '#0f172a',
                                        color: aiViewMode === 'before' ? '#fca5a5' : '#86efac',
                                        padding: '12px 14px',
                                        borderRadius: 6,
                                        fontSize: 12,
                                        lineHeight: 1.5,
                                        maxHeight: 400,
                                        overflow: 'auto',
                                        fontFamily: 'Consolas, Monaco, monospace',
                                        margin: 0,
                                        whiteSpace: 'pre',
                                    }}>{aiViewMode === 'before' ? (aiOriginal?.text || '(no original)') : (aiModalRow.ai_text || '(no g-code)')}</pre>
                                )}
                            </div>
                        </div>
                        );
                    })()}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAiModalOpen(false)} variant="contained" sx={{ backgroundColor: '#ec6e17', textTransform: 'none', ':hover': { backgroundColor: '#d35a0c' } }}>Close</Button>
                </DialogActions>
            </Dialog>

            {/* Bulk Yantra Intelligence Optimization modal — list candidates (have program_no, no ai_text), Optimize per row */}
            <Dialog
                open={bulkAiOpen}
                onClose={() => setBulkAiOpen(false)}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <span style={{ fontSize: 22 }}>🧠</span>
                    <span style={{ fontSize: 17, fontWeight: 600 }}>Bulk Yantra Intelligence Optimization</span>
                    <span style={{ marginLeft: 'auto', fontSize: 12, color: '#6b7280', fontWeight: 400 }}>
                        Components with a program loaded but no Yantra Intelligence optimization yet
                    </span>
                </DialogTitle>
                <DialogContent dividers sx={{ padding: 0 }}>
                    {(() => {
                        const candidates = datasource.filter(c => c.program_no && !c.ai_text && c.component_number);
                        if (candidates.length === 0) {
                            return (
                                <div style={{ padding: 40, textAlign: 'center', color: '#6b7280' }}>
                                    <div style={{ fontSize: 32, marginBottom: 8 }}>✓</div>
                                    <div style={{ fontSize: 14 }}>All components with a program have Yantra Intelligence optimization.</div>
                                </div>
                            );
                        }
                        return (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                                <thead>
                                    <tr style={{ background: 'var(--y-bg-soft, #fafafa)', color: '#374151', textAlign: 'left' }}>
                                        <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Code</th>
                                        <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Component</th>
                                        <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600 }}>Program</th>
                                        <th style={{ padding: '10px 14px', borderBottom: '1px solid var(--y-border, #e5e7eb)', fontWeight: 600, textAlign: 'right' }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {candidates.map(c => {
                                        const code = c.component_number;
                                        const state = bulkAiRunning[code];
                                        const result = bulkAiResults[code];
                                        return (
                                            <tr key={code} style={{ borderBottom: '1px solid #f3f4f6' }}>
                                                <td style={{ padding: '10px 14px', fontWeight: 500, color: '#111827' }}>{code}</td>
                                                <td style={{ padding: '10px 14px', color: '#374151', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.component_name}</td>
                                                <td style={{ padding: '10px 14px', color: '#7c3aed', fontFamily: 'monospace', fontWeight: 600 }}>{c.program_no}</td>
                                                <td style={{ padding: '10px 14px', textAlign: 'right' }}>
                                                    {state === 'running' ? (
                                                        <span style={{ fontSize: 12, color: '#6b7280' }}>
                                                            <CircularProgress size={12} sx={{ marginRight: 1 }} /> Running Yantra Intelligence…
                                                        </span>
                                                    ) : state === 'done' ? (
                                                        <span style={{ fontSize: 12, color: '#047857', fontWeight: 600 }}>
                                                            ✓ Done — {result?.timeDeltaSec ? `${result.timeDeltaSec > 0 ? '−' : '+'}${Math.abs(result.timeDeltaSec)}s` : 'no time delta'}, {result?.suggestions || 0} tips
                                                        </span>
                                                    ) : state === 'error' ? (
                                                        <Tooltip title={result?.error || ''}>
                                                            <span style={{ fontSize: 12, color: '#b91c1c', fontWeight: 600, cursor: 'help' }}>✗ Failed</span>
                                                        </Tooltip>
                                                    ) : (
                                                        <Button
                                                            size="small"
                                                            variant="contained"
                                                            onClick={() => runAiForComponent(c)}
                                                            sx={{ backgroundColor: '#7c3aed', textTransform: 'none', fontSize: 11, padding: '3px 12px', ':hover': { backgroundColor: '#6d28d9' } }}
                                                        >
                                                            Optimize
                                                        </Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        );
                    })()}
                </DialogContent>
                <DialogActions sx={{ padding: '10px 16px' }}>
                    <span style={{ fontSize: 11, color: '#6b7280' }}>Each Optimize click runs Claude on the program — takes 10–30s and uses tokens (~$0.05–$0.40 per component depending on program size).</span>
                    <span style={{ flex: 1 }} />
                    <Button onClick={() => { setBulkAiOpen(false); getComponents(); }} variant="outlined" sx={{ textTransform: 'none' }}>
                        Close & Refresh
                    </Button>
                </DialogActions>
            </Dialog>
                </div>
    );
};

export default ComponentRegistration;